var _style, _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDbIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108 107",
    style: {
      enableBackground: "new 0 0 108 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.27;fill:#FFFFFF;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    className: "st0",
    cx: 54,
    cy: 53.5,
    rx: 54,
    ry: 53.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-plus",
    className: "st1",
    d: "M79.3,49.5H74v-5.3c0-0.7-0.6-1.3-1.3-1.3H70c-0.7,0-1.3,0.6-1.3,1.3v5.3h-5.3 c-0.7,0-1.3,0.6-1.3,1.3v2.7c0,0.7,0.6,1.3,1.3,1.3h5.3v5.3c0,0.7,0.6,1.3,1.3,1.3h2.7c0.7,0,1.3-0.6,1.3-1.3v-5.3h5.3 c0.7,0,1.3-0.6,1.3-1.3v-2.7C80.7,50.1,80.1,49.5,79.3,49.5z M46,53.5c5.9,0,10.7-4.8,10.7-10.7c0-5.9-4.8-10.7-10.7-10.7 c-5.9,0-10.7,4.8-10.7,10.7c0,0,0,0,0,0C35.3,48.7,40.1,53.5,46,53.5C46,53.5,46,53.5,46,53.5z M53.5,56.2h-1.4 c-3.9,1.8-8.3,1.8-12.2,0h-1.4c-6.2,0-11.2,5-11.2,11.2v3.5c0,2.2,1.8,4,4,4h29.3c2.2,0,4-1.8,4-4v-3.5 C64.7,61.2,59.7,56.2,53.5,56.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbIcon2);
export default __webpack_public_path__ + "static/media/db-icon-2.2bd7100301489cfb36b2c07cdbdcce4c.svg";
export { ForwardRef as ReactComponent };